import React, { useState } from "react";
import axios from 'axios';
import { useSuperAdminAuth } from '../../../context/SuperAdminAuthContext';
import SEO from "../../../components/common/SEO";
import './SuperAdminLogin.css';

function SuperAdminLogin() {
    const { login } = useSuperAdminAuth();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [formMessage, setFormMessage] = useState({ text: '', type: '' });

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setFormMessage({ text: '', type: '' });

        if (!email || !password) {
            setFormMessage({ text: "Please enter email and password.", type: "error" });
            setIsLoading(false);
            return;
        }

        try {
            const apiUrl = `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api'}/superadmin/login`;
            const response = await axios.post(apiUrl, { email, password });
            const { admin, token, message } = response.data;

            setFormMessage({ text: message || "Login successful!", type: "success" });
            setTimeout(() => {
                login(token, admin);
            }, 1000);
        } catch (err) {
            const errorMessage = err.response?.data?.message || "Login failed. Please check your credentials.";
            setFormMessage({ text: errorMessage, type: "error" });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="superadmin-auth-container">

            <SEO
                title="Super Admin Login | Mangoloops"
                description="Secure login portal for Mangoloops Super Administrators."
            />

            <div className="superadmin-auth-card">
                <img
                    src="/logo-mangoloops.png"
                    alt="Mangoloops Logo"
                    className="superadmin-logo"
                />

                <h2 className="superadmin-heading">Access Super Admin Portal</h2>
                <p className="superadmin-subheading">Secure authentication required</p>

                {formMessage.text && (
                    <div className={`superadmin-message ${formMessage.type}`}>
                        {formMessage.text}
                    </div>
                )}

                <form onSubmit={handleLogin} style={{ width: '100%' }}>
                    <div className="superadmin-input-group">
                        <label>Email Address</label>
                        <input
                            type="email"
                            className="superadmin-input"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={isLoading}
                            required
                        />
                    </div>

                    <div className="superadmin-input-group">
                        <label>Password</label>
                        <div style={{ position: 'relative' }}>
                            <input
                                type={showPassword ? "text" : "password"}
                                className="superadmin-input"
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                disabled={isLoading}
                                required
                                style={{ paddingRight: '40px' }}
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    position: 'absolute',
                                    right: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                    color: '#6b7280',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: 0
                                }}
                                aria-label={showPassword ? "Hide password" : "Show password"}
                            >
                                {showPassword ? (
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                                ) : (
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                )}
                            </button>
                        </div>
                    </div>

                    <button
                        type="submit"
                        className="superadmin-btn"
                        disabled={isLoading || formMessage.type === 'success'}
                    >
                        {isLoading ? 'Authenticating...' : 'Login Securely'}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default SuperAdminLogin;
